import { Context } from "./Reducers/Store";
import React, { useContext } from "react";
import { Navigate, useLocation } from "react-router-dom";

function RequireAuth({ children, admin = false }) {
  const [state] = useContext(Context);
  const location = useLocation();

  if (!state.isLogged) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (admin && state.profile?.perfil !== "Administrador") {
    return <Navigate to="/jobs" replace />;
  }

  return children;
}

export default RequireAuth;
